'use client';

import { sendGTMEvent } from '@next/third-parties/google';
import { useEffect, useRef } from 'react';
import { ToggleFavourite } from './ToggleFavorite';

type ProductBigPreviewClientProps = {
  eventName?: string;
  showFavorite: boolean;
  productId: string;
  productOwnerId: string | null;
  productLink?: string;
  isFavourite: boolean;
};

export function ProductBigPreviewClient({
  eventName,
  showFavorite,
  productId,
  productOwnerId,
  productLink,
  isFavourite,
}: ProductBigPreviewClientProps) {
  const anchorRef = useRef<HTMLSpanElement | null>(null);

  useEffect(() => {
    if (!eventName) return;

    const cardRoot = anchorRef.current?.closest<HTMLElement>('[data-product-card-root]');
    if (!cardRoot) return;

    const onCardClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement | null;
      if (target?.closest('[data-product-favorite-control]')) {
        return;
      }
      sendGTMEvent({
        event: eventName,
        product: productId,
      });
    };

    cardRoot.addEventListener('click', onCardClick, true);

    return () => {
      cardRoot.removeEventListener('click', onCardClick, true);
    };
  }, [eventName, productId]);

  return (
    <>
      <span ref={anchorRef} className='hidden' />
      {showFavorite && (
        <div
          className='absolute bottom-[8px] end-[8px] w-[24px] h-[24px] flex justify-center items-center z-11'
          data-product-favorite-control='true'
        >
          <ToggleFavourite
            productId={productId}
            isFavourite={isFavourite}
            productOwnerId={productOwnerId}
            productLink={productLink}
          />
        </div>
      )}
    </>
  );
}
